import React, { Component } from 'react';
import PropTypes from 'prop-types';
import JourneyValue from '../../../shared/components/line_select/JourneyValue';

export default class LineValueContainer extends Component {
    static propTypes = {
        children: PropTypes.node,
        placeholder: PropTypes.string,
        value: PropTypes.object
    };

    render () {
        const { data } = this.props;

        return <JourneyValue value={data} {...this.props} />;
    }
}
